angular.module('cimerFrontEndApp')
.controller('DirectorAlternateCtrl',[ '$scope', '$routeParams', '$location', '$http', 'Session', 'ApiUrl',
    function ($scope, $routeParams, $location, $http, Session, ApiUrl) {
        "use strict";

        var sessionObject = Session.getSessionObject();
        if (!sessionObject.isAuthenticated) {
            $location.url('/');
            return;
        }
        if (!sessionObject.isDirector &&
            !sessionObject.isAdmin &&
            !sessionObject.isProjectAdmin) {
            $location.url('/');
            return;
        }

        var _grantapiUrl = ApiUrl.url('/Grant/');
        var _uploadapiUrl = ApiUrl.url('/Upload/');

        $http.get(_grantapiUrl + 'GrantsAndAlternates').then(function (response) {
            $scope.grants = response.data;
        }, function (err) {
            $location.path('error');
        });

        $scope.successMsg = '';
        $scope.errMsg = '';
        $scope.submitData = {
            AlternateEmail: null,
            grantID: null
        };

        $scope.removeAlternate = function (grantID, alternateID) {
            var data = {
                grantID: grantID,
                AlternateID: alternateID
            };

            $http.post(_uploadapiUrl + 'RemoveAlternate', data).then(function (response) {
                if (response.data) {

                    var grant;

                    for (var i = 0; i < $scope.grants.length; i++) {
                        grant = $scope.grants[i];
                        if (grant.GrantID === grantID) {
                            break;
                        }
                    }

                    if (!grant) {
                        return;
                    }

                    var alternateIndex;
                    for (i = 0; i < grant.Alternates.length; i++) {
                        var alternate = grant.Alternates[i];
                        if (alternate.UserID === alternateID) {
                            alternateIndex = i;
                            break;
                        }
                    }

                    grant.Alternates.splice(alternateIndex, 1);
                }
            }, function (err) {
                $location.path('error');
            });
        };

        $scope.createAlternate = function (grantID) {
            var grant;

            for (var i = 0; i < $scope.grants.length; i++) {
                grant = $scope.grants[i];
                if (grant.GrantID === grantID) {
                    break;
                }
            }

            if (!grant) {
                return;
            }

            var data = {
                grantID: grantID,
                AlternateEmail: grant.submitData.AlternateEmail
            };

            $http.post(_uploadapiUrl + 'CreateAlternate', data).then(function (response) {
                if (response.data.Added) {
                    grant.Alternates.push(response.data.User);
                    grant.submitData.AlternateEmail = '';
                }
            }, function (err) {
                $location.path('error');
            });
        };

    }]);
